/**
 * Created by mac on 11/3/25
 */

Mission.TYPE_SLOT_MACHINE = 21;

Mission.REGISTRATIONS.set(Mission.TYPE_SLOT_MACHINE, () => ({
    ...BaseMissionData(),
    name: "SlotMachine",
    startWindow: undefined,
    view: bundles.main.jsons.slotmachinescene_prefab_json,
    semaphore: Mission.SEMAPHORE_PRIMARY,
    available: cleverapps.config.availables.SLOT_MACHINE_MISSION,
    logic: SlotMachineMissionLogic,
    sideBarJson: bundles.sidebar.jsons.slot_machine_json,
    duration: "3 days",
    iconForce: Forces.SLOT_MACHINE_ICON
}));

RewardTypes.mission.icon[Mission.TYPE_SLOT_MACHINE] = bundles.reward_icons.frames.slot_machine_ticket;
